import React from 'react';

import { NotificationDetail } from 'components/blocks/Notification';

const DetailScreen = (props) => {
  return (
    <div className="page-main">
      <NotificationDetail />
    </div>
  );
};

export default DetailScreen;
